import { createSlice } from "@reduxjs/toolkit";

const classSectionSlice = createSlice({
  name: "classSection",
  initialState: {
    classSectionMapData : [],
    loading: false,
    error: null,
  },
  reducers: {
    getClassSectionRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getClassSectionSuccess: (state, action) => {
      state.loading = false;
      state.classSectionMapData = action.payload;
    },
    getClassSectionFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearClassSection: (state) => {
      state.classSectionMapData = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getClassSectionRequest,
  getClassSectionSuccess,
  getClassSectionFailure,
  clearClassSection,
} = classSectionSlice.actions;

export default classSectionSlice.reducer;
